// @flow
import $ from 'jquery';
import { removeInvalidFeedback } from '../views/common/JQueryView';

const invalidClass = 'is-invalid';
const jqueryValidationInvalidClass = 'jquery-validation-invalid';

export const jqueryValidationOptions = {
  errorPlacement: (error: any, element: any) => {
    element.closest('.form-group').append(error);
  },
  highlight: (element: any, errorClass: string) => {
    $(element).addClass(
      [errorClass, jqueryValidationInvalidClass, invalidClass].join(' '),
    );
  },
  unhighlight: (element: any, errorClass: string) => {
    const e = $(element);

    // remote ruleの初回submit時のunhighlight暴発対策
    setTimeout(() => {
      const hasError = !!e
        .closest('.form-group')
        .children(`.${errorClass}`)
        .text().length;
      if (hasError) return;

      e.removeClass(
        [errorClass, jqueryValidationInvalidClass, invalidClass].join(' '),
      );
    }, 0);
  },
};

function findFloatForms(element: any) {
  return element.find('.auto-floating-labels-form');
}

const floatControlSelector = '.form-group-float .form-control';

function findFloatControls(form: any) {
  return form.find(floatControlSelector);
}

function updateFloatControlLabelActive(control: any) {
  const isActive = control.is('select')
    ? control.find(':selected').text().length !== 0
    : control.val().length !== 0;

  if (isActive) {
    control.addClass('form-control-active');
  } else {
    control.removeClass('form-control-active');
  }
}

function findAndUpdateAllFloatControlsLabelActive(form: any) {
  const floatControls = findFloatControls(form);
  floatControls.each((index, element) => {
    updateFloatControlLabelActive($(element));
  });
}

function registerEventsToForm(form: any) {
  const registerEventToFloatControls = (
    event: string,
    callback: (event: any) => void,
  ) => {
    form.on(event, floatControlSelector, callback);
  };

  const removeErrors = (control: any) => {
    if (control.hasClass(jqueryValidationInvalidClass)) return;

    control.removeClass(invalidClass);
    removeInvalidFeedback(control);
  };

  registerEventToFloatControls('input change blur', (event: any) => {
    const floatControl = $(event.target);
    updateFloatControlLabelActive(floatControl);
    if (floatControl.val().length !== 0) {
      removeErrors(floatControl);
    }
  });

  registerEventToFloatControls('blur', (event: any) => {
    const floatControl = $(event.target);
    if ($('.show-calendar').is(':visible')) {
      floatControl.focus();
    }
  });

  // wrapper :custom_boolean
  form.on('change', '.custom-checkbox .custom-control-input', (event: any) => {
    removeErrors($(event.target));
  });

  // jquery-validationと併用した時のjpostal更新時エラー削除
  registerEventToFloatControls('change', (event: any) => {
    const floatControl = $(event.target);
    if (
      floatControl.hasClass(jqueryValidationInvalidClass) &&
      floatControl.val().length !== 0
    ) {
      floatControl.valid();
    }
  });
}

const observer = new MutationObserver((mutations: any) => {
  const addedNodes = mutations.flatMap((mutation: any) =>
    Array.from(mutation.addedNodes),
  );

  const forms = findFloatForms($(addedNodes));
  if (forms.length === 0) return;

  findAndUpdateAllFloatControlsLabelActive(forms);
  registerEventsToForm(forms);
});

observer.observe(document, {
  childList: true,
  subtree: true,
});

// ブラウザバック対応
$(window).on('pageshow', () => {
  const forms = findFloatForms($(document));
  findAndUpdateAllFloatControlsLabelActive(forms);
});
